import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTodaysDate } from '../redux/modules/registration';
import formatDate from '../modules/formatDate';

class Today extends Component {
  render() {
    return (
      <div className="Box">
        <span className="FormattedDate no-print">{formatDate(this.props.todaysDate)}</span>
        <span className="FormattedDate print-only">{formatDate(new Date())}</span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    todaysDate: state.registration.today,
  };
};

export default connect(mapStateToProps, { setTodaysDate })(Today);
